import { render, staticRenderFns } from "./CardProfilePricesPrice.vue?vue&type=template&id=4b3f2bd8"
import script from "./CardProfilePricesPrice.vue?vue&type=script&lang=js"
export * from "./CardProfilePricesPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports